import * as React from 'react';
import {Mutation} from 'react-apollo';
import {useSelector} from 'react-redux';
import {withRouter} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import type {
    UpdateDefaultStagesetForOnboardingWizard as UpdateDefaultStagesetForOnboardingWizardMutation,
    UpdateDefaultStagesetForOnboardingWizardVariables as UpdateDefaultStagesetForOnboardingWizardMutationVariables,
} from 'nutshell-graphql-types';

import {OpenableModals, useOpenableModal} from '../../../openable-modals';

import type {NutshellState} from '../../../../store';

import UPDATE_DEFAULT_STAGESET_FOR_ONBOARDING_WIZARD from '../../graphql/mutations/update-default-stageset-for-onboarding-wizard.graphql';
import {getOnboardingState} from '../../ui-selectors';

import {WizardComponent} from './wizard-component';

type Props = ContextRouter & {
    completeWizard: () => Promise<any>;
};

function WizardGraphQLComponent(props: Props) {
    const {isOpen, onClose} = useOpenableModal(OpenableModals.DESIGN_PIPELINE_WIZARD);

    const handleComplete = () => {
        props.completeWizard().then((stagesetId?: string | null) => {
            if (stagesetId) {
                props.history.replace(`/setup/sales-automation/${stagesetId}?onboard=true`);
            }
        });
    };

    if (!isOpen) {
        return <></>;
    }

    return <WizardComponent onClose={onClose} completeWizard={handleComplete} />;
}

class OnboardingMutation extends Mutation<
    UpdateDefaultStagesetForOnboardingWizardMutation,
    UpdateDefaultStagesetForOnboardingWizardMutationVariables
> {}

const WizardRouted = (props: ContextRouter) => {
    const selectedOptions = useSelector((state: NutshellState) => getOnboardingState(state));

    return (
        <OnboardingMutation mutation={UPDATE_DEFAULT_STAGESET_FOR_ONBOARDING_WIZARD}>
            {(updateStageset) => (
                <WizardGraphQLComponent
                    {...props}
                    completeWizard={() => {
                        return updateStageset({
                            variables: {
                                optionSelections: selectedOptions,
                            },
                        }).then((mutationResult) => {
                            if (!mutationResult || !mutationResult.data) return null;

                            if (mutationResult.data.updateDefaultStagesetForOnboardingWizard) {
                                return mutationResult.data.updateDefaultStagesetForOnboardingWizard
                                    .stageset.id;
                            } else {
                                return null;
                            }
                        });
                    }}
                />
            )}
        </OnboardingMutation>
    );
};

// @ts-expect-error
export const Wizard = withRouter<Record<any, any>>(WizardRouted);
